import React, { useState, useRef } from 'react'
import { Select, Button } from '@ow/comps'
import styled from '@emotion/styled'
import tw from 'twin.macro'
// import { rolesByOrg } from '@vt/apis/lib/v4/roles'
import SelectOrg from './SelectOrg'

const SelectUsers = styled.div`
  height: 5rem;
  z-index: 10000;
  .select-handle {
    font-weight: 600;
    ${tw`shadow-none ml-0`}
  }
  .select-handle-gray {
    background: #e2e8f0;
    border-radius: 1.875rem;
    ${tw`shadow-none ml-0`}
  }
  .select-group {
    color: #1c3faa;
    ${tw`ml-2`}
  }
`

const AddUserOperate = function ({
  updateSelRole,
  onClickAdd,
  isAddAbled,
  updateCurrentOrgId,
  useOrgApi = {},
}) {
  const popupRef = useRef(null)
  const { currentOrg, roles, orgs } = useOrgApi
  // const [roles, setRoles] = useState(currentOrgRoles || [])
  const [selectedOrg, setSelectedOrg] = useState(currentOrg || {})

  const onChangeRole = (v) => {
    updateSelRole(v)
  }
  const customStyles = {
    menu: (provided) => ({
      ...provided,
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? '' : '',
      width: '13rem',
    }),
    control: (provided) => ({
      ...provided,
    }),
    indicatorSeparator: () => ({
      width: '0',
    }),
  }
  const updateOrg = (obj) => {
    setSelectedOrg(obj)
    if (updateCurrentOrgId) {
      updateCurrentOrgId(obj.key)
    }
    // 更新roles
    // rolesByOrg({ parentOrgId: obj.key }).then((data = []) => {
    //   setRoles(
    //     data.map((item) => {
    //       return { value: item.slug, label: item.name, id: item.id }
    //     })
    //   )
    // })
  }

  return (
    <>
      <SelectUsers className="flex flex-wrap items-center">
        <div className="flex items-center">
          <label className="mr-5" style={{ whiteSpace: 'nowrap' }}>
            <b>
              <span className="text-red-500">*</span>
              &nbsp;添加到
            </b>
          </label>
          <div
            className="select-handle cursor-pointer rounded-full text-theme-10 bg-theme-14 py-2 px-3 flex flex-wrap flex-row items-center mr-5"
            onClick={() => {
              if (popupRef.current) {
                popupRef.current.open()
              }
            }}
          >
            {selectedOrg && selectedOrg.extData && selectedOrg.extData.label ? (
              <span
                title={selectedOrg.extData.label}
                className="w-10 text-ellipsis"
              >
                {selectedOrg.extData.label}
              </span>
            ) : (
              <span> + </span>
            )}
          </div>
        </div>
        <div className="flex items-center">
          <label className="mr-5" style={{ whiteSpace: 'nowrap' }}>
            <b>
              <span className="text-red-500">*</span>
              &nbsp;角色
            </b>
          </label>
          <Select
            className="w-52 mr-10 text-gray-700 placeholder-theme-13"
            styles={customStyles}
            closeMenuOnSelect
            isClearable
            allowClear={false}
            options={(roles || []).map((v) => {
              return { ...v, value: v.id, key: v.id }
            })}
            menuPlacement="top"
            onChange={onChangeRole}
            placeholder="选择角色"
          />
        </div>
        {onClickAdd && (
          <Button
            disabled={isAddAbled}
            className="mr-2"
            onClick={() => {
              if (onClickAdd) {
                onClickAdd()
              }
            }}
            type="primary"
          >
            添加
          </Button>
        )}
      </SelectUsers>

      <SelectOrg
        closeModal={() => {
          if (popupRef.current) {
            popupRef.current.close()
          }
        }}
        ref={popupRef}
        updateOrg={updateOrg}
        orgs={orgs}
      />
    </>
  )
}

export default AddUserOperate
